<template lang="pug">

  text-input(name="phone", :label="label", meta)

</template>

<script>

import TextInput from './TextInput'

export default {
  name: 'user-input-phone',

  components: {
    TextInput,
  },

  props: {
    label: {
      type: String,
      default: 'Phone',
    },
  },
}

</script>
